import _ from 'lodash'

const resourcesList = (state) => _.get(state, 'list')
const category = (state) => _.get(state, 'category')
const listMeta = (state) => _.get(state, 'listMeta')
const singleMeta = (state) => _.get(state, 'singleMeta')
const categoryResources = (state) => _.get(state, 'categoryResources')
const isLoading = (state) => _.get(state, 'isLoading')
const breadCrumbs = (state) => _.get(state, 'breadCrumbs')
const resource = (state) => _.get(state, 'resource')
const errors = (state) => _.get(state, 'errors')
const listView = (state) => _.get(state, 'listView')
const resourceType = (state) => _.get(state, 'resourcesType')
const resourceTypeMeta = (state) => _.get(state, 'resourcesTypeMeta')
const resourceAuthor = (state) => _.get(state, 'authors')
const resourceAuthorMeta = (state) => _.get(state, 'authorsMeta')

export default {
	resourcesList,
	isLoading,
	category,
	categoryResources,
	listMeta,
	singleMeta,
	breadCrumbs,
	resource,
	errors,
	listView,
	resourceType,
	resourceTypeMeta,
	resourceAuthor,
	resourceAuthorMeta,
}
